import { useCallback, useEffect, useState } from 'react';

export type Tema = 'dark' | 'light';

const CLAVE = 'athena-theme';

const leerGuardado = (): Tema | null => {
  try {
    const v = localStorage.getItem(CLAVE);
    return v === 'dark' || v === 'light' ? v : null;
  } catch {
    return null;
  }
};

/** Oscuro por defecto (decisión de Iván, 2026-09-20); el claro se recuerda por navegador. */
export function useTema(): { tema: Tema; alternar: () => void } {
  const [tema, setTema] = useState<Tema>(() => leerGuardado() ?? 'dark');

  useEffect(() => {
    document.documentElement.dataset['theme'] = tema;
    try {
      localStorage.setItem(CLAVE, tema);
    } catch {
      /* sin localStorage no se recuerda, pero la página funciona igual */
    }
  }, [tema]);

  const alternar = useCallback(() => setTema(t => (t === 'dark' ? 'light' : 'dark')), []);

  return { tema, alternar };
}
